export default "__VITE_ASSET__Btazxhnz__"